import BackendService from "./BackendService";

async function getTables() {
  return BackendService.getData("/kot/tables/");
}
async function createTables(data) {
  return BackendService.postData("/kot/tables/", data);
}
async function updateTables(id, data = {}) {
  return BackendService.put(`/kot/tables/${id}/`, data);
}
async function deleteTables(id) {
  return BackendService.destroy(`/kot/tables/${id}/`, "");
}
async function getAreas() {
  return BackendService.getData("/areas/");
}
async function updateArea(id, data = {}) {
  return BackendService.patch(`/areas/${id}/`, data);
}
async function createArea(data = {}) {
  return BackendService.post(`/areas/`, data);
}
async function deleteArea(id) {
  return BackendService.destroy(`/areas/${id}/`);
}

const TableService = {
  getTables,
  createTables,
  updateTables,
  deleteTables,
  getAreas,
  createArea,
  updateArea,
  deleteArea,
};

export default TableService;
